<template>
<div>
    <div
      id="graphs"
      class="anchor"
    ></div>
    <v-card
      class="pa-4 ma-0"
      elevation="4"
    >
      <h1>Active Stakes Ending</h1>
      <ul class="mb-5">
      </ul>

      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3">Time Interval:</v-col>
        <v-col cols="12" sm="9" md="9" lg="9" xl="9">
          <v-btn-toggle class="flex-wrap" v-model="toggle_timeinterval">
            <v-btn
              small
              @click="setTimeInterval(7)"
            >
              1 Week
            </v-btn>
            <v-btn
              small
              @click="setTimeInterval(30)"
            >
              1 Month
            </v-btn>
            <v-btn
              small
              @click="setTimeInterval(183)"
            >
              6 months
            </v-btn>
            <v-btn
              small
              @click="setTimeInterval(365)"
            >
              1 Year
            </v-btn>
            <v-btn
              small
              @click="setTimeInterval(365*5)"
            >
              5 Years
            </v-btn>
            <v-btn
              small
              @click="setTimeInterval(365*42)"
            >
              42 Years
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3">Period:</v-col>
        <v-col cols="12" sm="9" md="9" lg="9" xl="9">
          <v-btn
            small
            width="50"
            class="mr-1"
            :disabled="disablePreviousPeriode"
            @click="setPeriode('first')"
          >
            <v-icon small>mdi-skip-previous-outline</v-icon>
          </v-btn>
          <v-btn
            small
            width="50"
            class="mx-1"
            :disabled="disablePreviousPeriode"
            @click="setPeriode(-1)"
          >
            <v-icon small>mdi-menu-left-outline</v-icon>
          </v-btn>
          <span class="spanwithborder mx-1">{{period + 1}}</span>
          <v-btn
            small
            width="50"
            class="mx-1"
            :disabled="disableNextPeriode"
            @click="setPeriode(1)"
          >
            <v-icon small>mdi-menu-right-outline</v-icon>
          </v-btn>
          <v-btn
            small
            width="50"
            class="ml-1"
            :disabled="disableNextPeriode"
            @click="setPeriode('last')"
          >
            <v-icon small>mdi-skip-next-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3">Data Grouping:</v-col>
        <v-col cols="12" sm="9" md="9" lg="9" xl="9">
          <v-btn-toggle v-model="toggle_datagrouping">
            <v-btn
              small
              @click="setDataGrouping(false)"
            >
              No
            </v-btn>
            <v-btn
              small
              @click="setDataGrouping(true)"
            >
              Yes
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3">Reload Data:</v-col>
        <v-col cols="12" sm="9" md="9" lg="9" xl="9">
          <v-btn
            small
            @click="generateData()"
            class="mr-5"
          >
            <v-icon
              class="mr-1"
              small
            >mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-overlay
        :value="graphLoading"
        absolute="absolute"
        opacity="0.7"
      >
        <div class="text-center">
          <v-progress-circular
            indeterminate
            size="60"
            width="10"
            color="#29abb5"
            class="my-5"
          ></v-progress-circular>
          <p>
            Refreshing Graph...
          </p>
        </div>


      </v-overlay>
      <highcharts :options="chartOptions"></highcharts>

    </v-card>
  </div>
</template>

<script>
import {
    Chart
  } from "highcharts-vue";
  import Highcharts from "highcharts";
  import HighchartsMore from "highcharts/highcharts-more";
  import dark from "highcharts/themes/dark-unica";

  import {
    apiUrl
  } from "../utils/dataPoller";

  HighchartsMore(Highcharts);
  dark(Highcharts);

  Highcharts.setOptions({
    colors: ['#3c44b1', '#33b1f6', '#29abb5', '#ffdc00aa']
  });

  import {
    mapState
  } from 'vuex';

  import axios from "axios";

  export default {
    name: 'stakes',
    data() {
      return {
        data: [],
        graphLoading: false,
        chart: null,
        endDayFrom: 51,
        endDayTo: 51 + 365,
        timeInterval: 365,
        dataGrouping: false,
        period: 1,
        disablePreviousPeriode: true,
        disableNextPeriode: false,
        toggle_timeinterval: 1,
        toggle_datagrouping: 0,
        chartOptions: {
          chart: {
            // type: 'null',
            backgroundColor: null,
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            style: {
              fontFamily: "Roboto, sans-serif"
            }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: 'Click and drag to zoom in. Hold shift to pan.'
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          tooltip: {
            backgroundColor: '#555555',
            borderRadius: 10,
            borderWidth: 1,
            shared: true,
            split: true,
            formatter: function(tooltip) {
              let tooltipArray = tooltip.defaultFormatter.call(this, tooltip);
              let startTimestamp = Date.UTC(2020, 10, 11);
              let timestamp = startTimestamp + (this.x - 1) * 86400000;
              tooltipArray[0] = Highcharts.dateFormat('%Y-%m-%d', timestamp) + " (Day " + this.x + ")";
              return tooltipArray;
            }
          },
          xAxis: [{
            type: 'linear',
            title: {
              text: 'Wise Day',
            },
            labels: {
              format: "Day {value}"
            },
            plotLines: [],
          }],
          yAxis: [{
              title: {
                text: 'Daily Ending Stakes (WISE)',
                style: {
                  color: Highcharts.getOptions().colors[1]
                },
              },
              labels: {
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              plotLines: []
            },
            {
              opposite: true,
              title: {
                text: 'Cumulative Ending Stakes (WISE)',
                style: {
                  color: Highcharts.getOptions().colors[3]
                },
              },
              labels: {
                style: {
                  color: Highcharts.getOptions().colors[3]
                }
              },
            },
          ],
          legend: {
            enabled: true
          },
          plotOptions: {
            column: {
              yAxis: 0,
              marker: {
                radius: 5
              },
              dataGrouping: {
                enabled: true
              },
              lineWidth: 5,
              states: {
                hover: {
                  lineWidth: 5
                }
              },
              // threshold: null
            },
            line: {
              // pointInterval: 86400000, // one day
              // pointStart: Date.UTC(2020, 10, 8),
              dataGrouping: {
                enabled: true
              },
              yAxis: 1,
              marker: {
                radius: 0
              },
              lineWidth: 1,
              states: {
                hover: {
                  lineWidth: 3
                }
              },
              // threshold: null
            },
          },
          series: [{
              type: 'column',
              name: 'Daily Ending Stakes',
              visible: true,
              zIndex: 0,
              yAxis: 0,
              color: Highcharts.getOptions().colors[1],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
            {
              type: 'line',
              name: 'Cumulative Ending Stakes',
              visible: true,
              zIndex: 2,
              yAxis: 1,
              color: Highcharts.getOptions().colors[3],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
          ],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 600
              },
              chartOptions: {
                yAxis: [{
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  }
                ]
              }
            }]
          }
        }
      }
    },
    components: {
      highcharts: Chart
    },
    mounted() {
      this.endDayFrom = this.$store.state.currentWiseDay;
      this.setTimeInterval(30);
    },
    computed: {
      ...mapState({
        currentWiseDay: state => state.currentWiseDay,
      }),
    },
    watch: {
      currentWiseDay() {
        this.endDayFrom = this.$store.state.currentWiseDay;
        this.setTimeInterval(this.timeInterval);
      }
    },
    methods: {
      setTimeInterval(days) {
        this.timeInterval = days;
        this.period = 0;
        this.setPeriode(0);
        // this.endDayTo = this.endDayFrom + days;
        // this.generateData();
      },
      setDataGrouping(dataGrouping) {
        this.dataGrouping = dataGrouping;
        this.generateData();
      },
      setPeriode(direction) {
        let maxPeriod = Math.ceil(15330 / this.timeInterval);
        if (direction === "first") {
          this.period = 0;
        } else if (direction === "last") {
          this.period = maxPeriod;
        } else {
          this.period = this.period + direction;
        }
        this.endDayFrom = this.$store.state.currentWiseDay + this.period * this.timeInterval;
        this.endDayTo = this.endDayFrom + this.timeInterval - 1;
        if (this.period <= 0) {
          this.disablePreviousPeriode = true;
        } else {
          this.disablePreviousPeriode = false;
        }
        if (this.period >= maxPeriod) {
          this.disableNextPeriode = true;
        } else {
          this.disableNextPeriode = false;
        }

        this.generateData();
        // this.dataGrouping = dataGrouping;
        // this.generateData();
      },

      receivedAllNeededData() {
        return (
          this.$store.state.currentWiseDay > 0
        );
      },

      async generateData() {
        if (!this.receivedAllNeededData()) {
          return;
        }
        // this.endDayFrom = this.$store.state.currentWiseDay;
        // this.endDayTo = this.endDayFrom + this.timeInterval;
        this.graphLoading = true;

        // let url_stakestarts = "https://wiseinfo.io/api_alpha/stakestarts_byenddayrange"
        // let url_stakends = "https://wiseinfo.io/api_alpha/stakeends_stakeids"
        let url_stakestarts = apiUrl + "/stakestarts_byenddayrange"
        let url_stakends = apiUrl + "/stakeends_stakeids"

        let parameters = {
          params: {
            endDayFrom: this.endDayFrom,
            endDayTo: this.endDayTo,
          }
        };
        let stakesMap = new Map();
        let stakeStarts = await axios.get(url_stakestarts, parameters);
        let stakeEnds = await axios.get(url_stakends, parameters);
        let stakeEndsArray = stakeEnds.data.map(stakeEnd => stakeEnd.stakeId);

        // initialize map with all days and 0
        for (let i = parameters.params.endDayFrom; i <= parameters.params.endDayTo; i++) {
          stakesMap.set(i, 0);
        }

        for (let stakeStart of stakeStarts.data) {
          let stakeId = stakeStart.stakeId;
          if (!stakeEndsArray.includes(stakeId)) {
            let endDay = stakeStart.endDay;
            let stakedAmount = stakeStart.stakedAmount;
            let currentDayValue = stakesMap.get(endDay);
            stakesMap.set(endDay, currentDayValue + stakedAmount);
          }
        }

        this.chartOptions.series[0].data = Array.from(stakesMap.values());
        this.chartOptions.xAxis[0].categories = Array.from(stakesMap.keys());

        let cumulativeSum = Array.from(stakesMap.values()).map((sum => value => sum += value)(0));

        this.chartOptions.series[1].data = cumulativeSum;

        this.chartOptions.plotOptions.column.dataGrouping.enabled = this.dataGrouping;
        this.chartOptions.plotOptions.line.dataGrouping.enabled = this.dataGrouping;

        this.graphLoading = false;
      },
    },
  }
</script>

<style scoped>
.spanwithborder {
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 0.9em;
  }
</style>
